import ServicePageTemplate from '../ServicePageTemplate';

const ASSETS = {
  residential: "https://images.pexels.com/photos/6653889/pexels-photo-6653889.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

const ResidentialService = () => {
  return (
    <ServicePageTemplate
      title="Residential Plumbing"
      subtitle="Home Plumbing Services"
      image={ASSETS.residential}
      description="Bruce Nelson Plumbing & Heating provides comprehensive residential plumbing services for homeowners throughout the Twin Cities. From routine maintenance to urgent repairs, our licensed technicians deliver quality workmanship and reliable service for all your home plumbing needs."
      features={[
        'Licensed, bonded, and insured technicians',
        'Older home specialists with expertise in vintage plumbing',
        'Upfront, transparent pricing with no surprises',
        'Same-day service available',
        'Quality parts and materials',
        'We stand by our work',
      ]}
      services={[
        'Faucet Installation & Repair',
        'Toilet Repair & Replacement',
        'Water Heater Services',
        'Drain Cleaning & Repair',
        'Garbage Disposal Installation',
        'Pipe Repair & Replacement',
        'Sump Pump Installation',
        'Water Softener Installation',
        'Water Filter Systems',
        'Fixture Installation',
        'Leak Detection & Repair',
        'Backflow Prevention',
      ]}
      relatedServices={[
        { title: 'Water Heaters', link: '/services/water-heaters', description: 'Installation, repair, and replacement services.' },
        { title: 'Remodeling', link: '/services/remodeling', description: 'Kitchen and bathroom plumbing renovations.' },
        { title: 'Boilers', link: '/services/boilers', description: 'Residential boiler services.' },
      ]}
    />
  );
};

export default ResidentialService;
